/* RESPONSIBLE TEAM: team-ai-agent */
import BaseValidator from 'ember-cp-validations/validators/base';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type Fin from 'embercom/models/operator/visual-builder/step/fin';

export default class FinHasAiContentReady extends BaseValidator {
  @service declare intl: IntlService;

  validate(_value: unknown, _options: ValidationOptions, model: Fin) {
    if (model.isFinSdr) {
      return true;
    }

    let aiContentLibrarySummary = model.contentImportService.aiContentLibrarySummary;
    let contentSummaries = Object.values(aiContentLibrarySummary);
    let usesResolutionsWithCustomAnswers = model.app.usesResolutionsWithCustomAnswers;

    if (model.app.isStandaloneApp) {
      if (model.finStandaloneService.isLoadingAiContentLibrarySummary) {
        return true;
      }
    } else if (contentSummaries.length === 0 || model.customAnswerCount === -1) {
      return true; // to avoid the invalid 'flash' while the summaries and answers are being fetched
    }

    let hasAiContentReadyForFin = contentSummaries.some(
      (contentSummary) => contentSummary.used_by_fin_count > 0,
    );
    let hasLiveCustomAnswers = model.customAnswerCount > 0;

    // For Pricing 5 customers, we want live custom answers to be considered Fin content
    if (usesResolutionsWithCustomAnswers && hasLiveCustomAnswers) {
      return true;
    }

    if (!hasAiContentReadyForFin) {
      return this.intl.t('ai-agent.profiles.validation-errors.ai-content-not-ready');
    }

    return true;
  }

  static getDependentsFor() {
    return [
      'model.useAiAnswers',
      'model.app.isStandaloneApp',
      'model.app.usesResolutionsWithCustomAnswers',
      'model.contentImportService.aiContentLibrarySummary',
      'model.finStandaloneService.isLoadingAiContentLibrarySummary',
      'model.customAnswerCount',
      'model.selectedAgent',
      'model.isFinSdr',
    ];
  }
}
